import { ReactComponent as IncidentIcon } from "../../../assets/icons/Caution.svg";
import { Separator } from "../../../components/ui/common";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { useGetIncidentReportStatsQuery } from "../incidentReportApiSlice";

const IncidentReportDashStats = () => {
  const { data, isLoading } = useGetIncidentReportStatsQuery();

  const expenseStat = data?.data ?? {
    totalAccidentReports: 0,
    incidentTotal: 0,
    accidentTotal: 0,
  };

  const cards = [
    {
      label: "Total report",
      value: `${expenseStat.totalAccidentReports.toLocaleString()}`,
      icon: <IncidentIcon className="h-8 w-8" />,
      index: 0,
    },
    {
      label: "No of incidents",
      value: `${expenseStat.incidentTotal.toLocaleString()}`,
      icon: <IncidentIcon className="h-8 w-8" />,
      index: 1,
    },
    {
      label: "No of accidents",
      value: `${expenseStat.accidentTotal.toLocaleString()}`,
      icon: <IncidentIcon className="h-8 w-8" />,
      index: 2,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value, icon, index }) => (
        <>
          <DashboardCard
            key={label}
            icon={icon}
            value={isLoading ? "0" : value}
            label={label}
            className="w-[300px]"
          />

          {index < cards?.length - 1 && <Separator />}
        </>
      ))}
    </div>
  );
};

export default IncidentReportDashStats;
